export const rangeNumbers = (start: number, end: number) => {
  if (end < start) {
    throw new Error('End is inferior or equal to start');
  }

  if (end === start) {
    return [];
  }

  const length = end - start;

  return Array.from<number>({ length }).map((_, index) => index + start);
};

export const groupByToMap = <T, K>(arr: T[], keyFn: (i: T) => K): Map<K, T[]> =>
  arr.reduce((m, item) => {
    const key = keyFn(item);
    const value = m.get(key);

    if (!value) {
      m.set(key, [item]);
    } else {
      value.push(item);
    }

    return m;
  }, new Map<K, T[]>());

export const groupBy = <T, K>(arr: T[], keyFn: (i: T) => K): [K, T[]][] =>
  Array.from(groupByToMap(arr, keyFn));
